module.exports = __webpack_public_path__ + "img/1463106870.0c6fa088.jpg";